export const productList = [
  { id: 1, productName: "Dell E1916HV 18.5 Inch", price: 15000, stockQuantity: 30 },
  { id: 2, productName: "Asus Vivobook X515MA", price: 25000, stockQuantity: 15 },
  { id: 3, productName: "Canon Eos 4000D 18MP", price: 35000, stockQuantity: 40 },
];
